<script lang="ts">
    import type { PageProps } from '@kestrel/server';
    import ApmBoundary from '@shared/components/apm-boundary/ApmBoundary.svelte';
    import TileListRoute from '@tilelist/application/wiring/tile-list-page/TileListRoute.svelte';

    let { data }: PageProps<typeof import('./page.server.ts')> = $props();
</script>

<ApmBoundary scope="tilelist">
    <TileListRoute result={data} />

    {#snippet failed()}
        <TileListRoute result={{ state: 'error' }} />
    {/snippet}
</ApmBoundary>
